/* eslint-disable */
const state = {
    pdc : null,
    region: null,
    dealer: null,
    type: null,
    month: null,
    year: null
}

const getters = {
    //PDC
    getPdc: (state) => {
        return state.pdc
    },

    //Region
    getRegion: (state) => {
        return state.region
    },

    //Dealer
    getDealer: (state) => {
        return state.dealer
    },
    getDealerByRegion : (state) => (region) => {
      if(region == null || region.length == 0) return state.dealer
      let regions = Array.isArray(region) ? region : [region];
      return state.dealer.filter((singleDealer) => { return regions.indexOf(singleDealer.region) !== -1 })
    },

    //Type
    getType: (state) => {
        return state.type
    },

    //Month
    getMonth: (state) => {
        return state.month
    },

    //Year
    getYear: (state) => {
        return state.year
    },
    // getCodeMarket : (state) => (category, segment, subSeries, type) => {
    //   if(
    //     (category == null || category.length == 0) &&
    //     (segment == null || segment.length == 0) &&
    //     (subSeries == null || subSeries.length == 0) &&
    //     (type == null || type.length == 0)
    //   ) return state.codeMarket

    //   var counter = 0;
    //   var categories = []
    //   var segments = []
    //   var subSerieses = []
    //   var types = []
    //   var compiledStr = "state.codeMarket.filter((singleCodeMarket) => { return "

    //   if (category != null && category.length > 0){
    //     categories = category.map(a => a.category)
    //     compiledStr += "categories.indexOf(singleCodeMarket.category) !== -1 &&"
    //     counter++;
    //   }

    //   if(segment != null && segment.length > 0){
    //     segments = segment.map(a => a.segment)
    //     compiledStr += "segments.indexOf(singleCodeMarket.segment) !== -1 &&"
    //     counter++;
    //   }

    //   if(subSeries != null && subSeries.length > 0){
    //     subSerieses = subSeries.map(a => a.subseries)
    //     compiledStr += "subSerieses.indexOf(singleCodeMarket.subseries) !== -1 &&"
    //     counter++;
    //   }

    //   if(type != null && type.length > 0){
    //     types = type.map(a => a.type)
    //     compiledStr += "types.indexOf(singleCodeMarket.type) !== -1 &&"
    //     counter++;
    //   }

    //   if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";

    //   return eval(compiledStr)
    // },
    getFilterOptions: (state) => {
        return {
            pdc : state.pdc,
            region: state.region,
            dealer: state.dealer,
            type: state.type,
            month: state.month,
            year: state.year
        }
    }
}

const mutations = {
    pdcStatus(state, pdc) {
        if (pdc) state.pdc = pdc;
        else delete state.pdc;
    },
    regionStatus(state, region) {
        if (region) state.region = region;
        else delete state.region;
    },
    dealerStatus(state, dealer) {
        if (dealer) state.dealer = dealer;
        else delete state.dealer;
    },
    typeStatus(state, type) {
        if (type) state.type = type;
        else delete state.type;
    },
    monthStatus(state, month) {
        if (month) state.month = month;
        else delete state.month;
    },
    yearStatus(state, year) {
        if (year) state.year = year;
        else delete state.year;
    },
    filterOptionsStatus(state, filterOptions) {
        if (filterOptions) {
            state.pdc = (filterOptions['pdc'] != null) ? filterOptions['pdc'] : null;
            state.region = (filterOptions['region'] != null) ? filterOptions['region'] : null;
            state.dealer = (filterOptions['dealer'] != null) ? filterOptions['dealer'] : null;
            state.type = (filterOptions['type'] != null) ? filterOptions['type'] : null;
            state.month = (filterOptions['month'] != null) ? filterOptions['month'] : null;
            state.year = (filterOptions['year'] != null) ? filterOptions['year'] : null;
        } else {
            //Reset and delete all filterOptions;
            let keys = Object.keys(state);
            for (var i in keys) delete state[keys[i]];
        }
    }
}

const actions = {
    setPdc({ commit }, pdc) {
        commit('pdcStatus', pdc);
    },
    setRegion({ commit }, region) {
        commit('regionStatus', region);
    },
    setDealer({ commit }, dealer) {
        commit('dealerStatus', dealer);
    },
    setType({ commit }, type) {
        commit('typeStatus', type);
    },
    setMonth({ commit }, month) {
        commit('monthStatus', month);
    },
    setYear({ commit }, year) {
        commit('yearStatus', year);
    },
    setFilterOptions({ commit }, filterOptions) {
        commit('filterOptionsStatus', filterOptions);
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}